<template>
    <FormItem :label="label" :required="required">
      <template v-if="editable">
      <RadioGroup :value="strValue" @input="$emit('input',$event)">
        <div class="flex-wrap" style="flex-wrap:wrap;gap:5px">
        <template v-for="o in options">
            <Radio :label="o.key" :key="o.key" :disabled="!editable" :border="config.border" style="margin-right:40px;">
              <Icon v-if="o.icon" :type="o.icon"></Icon>
              <span>{{o.name}}</span>
          </Radio>
        </template>
        </div>
      </RadioGroup>
    </template>
      <template v-else>
        <div>{{val_objects}}</div>
      </template>
   </FormItem>
  </template>

<script>
import defaultValueMixin from '../mixins/default-value';
export default {
  mixins: [defaultValueMixin],
  cname: '格式条款选择器',
  icon: 'danxuan',
  corder: 45,
  properties: [],
  props: ['fkey', 'config', 'value', 'editable', 'label', 'required'],
  initModel(e) {
    if (!e.config || !e.config.options) {
      e.config = {
      };
    } else {
      e.config = {
      };
    }
  },
  computed: {
    strValue() {
      if (this.value !== undefined) {
        const value = this.value || 0;
        return value.toString();
      }
    },
    val_objects() {
      return (this.options.find((t)=>t.key == v) || {}).name;
    },
    options() {
      let options = ['选用', '不选用', '自定义'];
      if (Array.isArray(options)) {
        if (options && typeof options[0] != 'object') {
          options = options.map((v, i)=>({
            key: i,
            name: v,
          }));
        }
      }
      if (this.config.simple) {
        options = options.map((v)=>({key: v.name, name: v.name}));
      }
      return options;
    },
  },
};
</script>

  <style lang="less">
  .l-full{
    position: relative;
    height:100%;
    width:100%;
  }
  </style>
